import type { BrandLogo as BrandLogoType, Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSImage } from '@swf/cms';
import PokerStarsIcon from '@swf/core/assets/pokerstars-logo-standalone.svg';

interface Props {
  inMenu?: boolean;
  brandIcon: Reference[];
}

const BrandIconV2: React.FC<Props> = ({ inMenu = false, brandIcon }) => {
  if (brandIcon?.length) {
    const [{ desktop, tablet, mobile }] = brandIcon as BrandLogoType[];
    if (inMenu) {
      return <CMSImage {...mobile} />;
    }

    return (
      <>
        <CMSImage {...tablet} />
        <CMSImage {...desktop} />
      </>
    );
  }

  return <PokerStarsIcon />;
};

export default BrandIconV2;
